import { Name } from "@app/types/enums";
import {
  getRelAttribute,
  getTargetAttribute,
} from "@routes/Article/components/StoryElements/Annotation/utils/helpers";
import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";
import { getFieldValue } from "@util/helpers";
import { isEmpty } from "lodash-es";

export default function AnnotationComponentExternalLink({
  children,
  element,
}: AnnotationComponentProps): React.ReactElement {
  const uri = getFieldValue(element?.fields || [], Name.Uri);
  const isNewWindow = !!getFieldValue(element?.fields || [], Name.NewWindow);
  const isNoFollow = !!getFieldValue(element?.fields || [], Name.NoFollow);
  const relAttribute = [getRelAttribute(isNewWindow, isNoFollow), "noreferrer"]
    .filter(Boolean)
    .join(" ");
  const targetAttribute = getTargetAttribute(isNewWindow);

  return (
    <>
      {typeof uri === "string" && !isEmpty(uri) ? (
        <a href={uri} target={targetAttribute} rel={relAttribute}>
          <u>{children}</u>
        </a>
      ) : null}
    </>
  );
}
